import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/detail',
    name: 'detail',
    component: () => import('../views/NewsDetail.vue')
  },
  {
    path: '/details',
    name: 'details',
    component: () => import('../views/zhongbiao.vue')
  },
  {
    path: '/rdetails',
    name: 'rdetails',
    component: () => import('../views/feibiao.vue')
  },
  {
    path: '/xdetails',
    name: 'xdetails',
    component: () => import('../views/xunjia.vue')
  },
  {
    path: '/bdetails',
    name: 'bdetails',
    component: () => import('../views/biangeng.vue')
  },
  {
    path: '/sdetails',
    name: 'sdetails',
    component: () => import('../views/zhongzhi.vue')
  },
]

const router = new VueRouter({
  routes
})

export default router
